import React, { Fragment } from 'react'
import { connect } from '@cerebral/react'
import { state, props } from 'cerebral/tags'
import { css } from 'aphrodite'
import { PillContainer } from 'components/Common/PillContainer'
import themes from './themes'
import { Pill } from 'components/Common/PillContainer/Pill'
import { t } from '@billes/translator-client'

export default connect(
  {
    resource: state`${props`path`}.*`
  },
  ({ label, type, editMode, theme, path }) => {
    const styles = themes[theme]

    return (
      <Fragment>
        <div className={css(styles.fieldContainer)}>
          {label ? (
            <div className={css(styles.label)}>
              {t(`bms.media.tagsMenu.labels.${label}`)}
            </div>
          ) : null}
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <PillContainer
              path={path}
              renderTag={({ key, path }) => {
                return (
                  <Pill
                    key={key}
                    path={path}
                    type={type}
                    theme={theme}
                    editMode={editMode}
                  />
                )
              }}
            />
          </div>
        </div>
      </Fragment>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/FilterMenu/Section/pillHolder.js